import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import {
  routesWithMinimalFooter,
  routesWithNoFooter,
  routesWithNoFooterMobileTablet,
} from 'components/App/Routes/footerRouteConfig'

export function hasSiteFooter(pathname: string, isMobileOrTablet: boolean): boolean {
  if (matchLocaleAwarePath(pathname, { path: routesWithNoFooter })) {
    return false
  }

  if (matchLocaleAwarePath(pathname, { path: routesWithMinimalFooter })) {
    return true
  }

  if (matchLocaleAwarePath(pathname, { path: routesWithNoFooterMobileTablet })) {
    return !isMobileOrTablet
  }

  return true
}
